export default __webpack_public_path__ + "next-js.f185b0ae.png";